<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-menu-button auto-hide="false" data-test="sidemenuButton"></ion-menu-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Tickets</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-item-divider color="tertiary" data-test="pendingSection">
        {{pendingTickets.length}} Pending ticket(s) defined.
    </ion-item-divider>

    <ion-list id="pendingSection" class="ion-padding" data-test="pendingTickets">
        @for (ticket of pendingTickets; track $index) {
        <ion-item-sliding [disabled]="vb.disabled">
            <ion-item [disabled]="vb.disabled" class="ion-text-wrap alternateColor" detail="true" href="javascript:;"
                (click)="onTicketClick(ticket.uid)">
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">Created: {{ticket.createdDate | myTimestamp:'MMMM do yyyy, hh:mm:ss
                        a'}}</span><br />
                    <span class="line2">Passenger: {{ticket.passengerName}}</span><br />
                    <span class="line2">Type: {{getType(ticket)}}</span><br />
                    <span class="line2">To: {{getLocationName(ticket)}}</span><br />
                    <span class="line2">Address: {{getFullAddress(ticket)}}</span><br />
                    <span class="line2">Note: {{ticket.note}}</span>
                </ion-label>
            </ion-item>

            <ion-item-options>
                <ion-buttons>
                    <ion-button [disabled]="vb.disabled" id="deleteTicket" color="danger"
                        (click)="onConfirmDeleteTicket(ticket)">
                        <ion-icon name="trash"></ion-icon>
                        Delete
                    </ion-button>
                    <!-- I removed the reset button because the ticket is already pending. -->
                </ion-buttons>
            </ion-item-options>
        </ion-item-sliding>
        }
    </ion-list>

    <ion-item-divider color="tertiary" id="assignedHeader">
        {{assignedTickets.length}} Assigned ticket(s) defined.
    </ion-item-divider>
    <ion-list>
        @for (ticket of assignedTickets; track $index) {
        <ion-item-sliding [disabled]="vb.disabled">
            <ion-item [disabled]="vb.disabled" class="ion-text-wrap">
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">Passenger: {{ticket.passengerName}}</span><br />
                    <span class="line2">Type: {{getType(ticket)}}</span><br />
                    <span class="line2">To: {{getLocationName(ticket)}}</span><br />
                    <!-- <span class="line2">To: {{ticket.locationName}}</span><br /> -->
                    <span class="line2">Note: {{ticket.note}}</span>
                </ion-label>
            </ion-item>

            <!-- If the ticket is part of a route, resetting or deleting the ticket screws up the route.
         So removing this option forces the user/driver to delete the route first which will reset
         the ticket back to pending and then it can be deleted. -->
            @if (debugMode) {
            <ion-item-options>
                <ion-button [disabled]="vb.disabled" id="resetTicket1" color="danger"
                    (click)="onConfirmResetStatus(ticket)">
                    <ion-icon name="refresh"></ion-icon>
                    Reset
                </ion-button>
            </ion-item-options>
            }
        </ion-item-sliding>
        }
    </ion-list>

    <ion-item-divider color="tertiary" id="enrouteHeader">
        {{enrouteTickets.length}} En Route ticket(s) defined.
    </ion-item-divider>
    <ion-list>
        @for (ticket of enrouteTickets; track $index) {
        <ion-item-sliding [disabled]="vb.disabled">
            <ion-item [disabled]="vb.disabled" class="ion-text-wrap">
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">Passenger: {{ticket.passengerName}}</span><br />
                    <span class="line2">Type: {{getType(ticket)}}</span><br />
                    <span class="line2">To: {{getLocationName(ticket)}}</span><br />
                    <span class="line2">Note: {{ticket.note}}</span>
                </ion-label>
            </ion-item>

            <!-- If the ticket is part of a route, resetting or deleting the ticket screws up the route.  So removing
    this option forces the user to delete the route first which will reset the ticket back to pending and
    then it can be deleted. -->
            @if (debugMode) {
            <ion-item-options>
                <ion-button [disabled]="vb.disabled" id="resetTicket2" color="danger"
                    (click)="onConfirmResetStatus(ticket)">
                    <ion-icon name="refresh"></ion-icon>
                    Reset
                </ion-button>
            </ion-item-options>
            }
        </ion-item-sliding>
        }
    </ion-list>

    <ion-item-divider color="tertiary" id="currentHeader">
        {{currentTickets.length}} Current ticket(s) defined.
    </ion-item-divider>
    <ion-list>
        @for (ticket of currentTickets; track $index) {
        <ion-item-sliding [disabled]="vb.disabled">
            <ion-item [disabled]="vb.disabled">
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">Passenger: {{ticket.passengerName}}</span><br />
                    <span class="line2">Type: {{getType(ticket)}}</span><br />
                    <span class="line2">To: {{getLocationName(ticket)}}</span><br />
                    <span class="line2">Note: {{ticket.note}}</span>
                </ion-label>
            </ion-item>

            <!-- If the ticket is part of a route, resetting or deleting the ticket screws up the route.  So removing
    this option forces the user to delete the route first which will reset the ticket back to pending and
    then it can be deleted. -->
            @if (debugMode) {
            <ion-item-options>
                <ion-button [disabled]="vb.disabled" id="resetTicket3" color="danger"
                    (click)="onConfirmResetStatus(ticket)">
                    <ion-icon name="refresh"></ion-icon>
                    Reset
                </ion-button>
            </ion-item-options>
            }
        </ion-item-sliding>
        }
    </ion-list>

    <ion-item-divider color="tertiary" id="completedHeader">
        <!-- {{completedTickets.length}} Completed ticket(s) defined. -->
        Today's Completed tickets.
    </ion-item-divider>
    <ion-list>
        @for (ticket of completedTickets; track $index) {
        <ion-item-sliding [disabled]="vb.disabled">
            <ion-item [disabled]="vb.disabled">
                <ion-label class="ion-text-wrap" [class.urgent]="ticket.isUrgent">
                    <span class="line1">Passenger: {{ticket.passengerName}}</span><br />
                    <span class="line2">Type: {{getType(ticket)}}</span><br />
                    <!-- <span class="line2">To: {{ticket.locationName}}</span><br />
                    <span class="line2">Note: {{ticket.note}}</span> -->
                </ion-label>
            </ion-item>

            <!-- If the ticket is part of a route, resetting or deleting the ticket screws up the route.  So removing
    this option forces the user to delete the route first which will reset the ticket back to pending and
    then it can be deleted. -->
            @if (debugMode) {
            <ion-item-options>
                <ion-button [disabled]="vb.disabled" id="resetTicket4" color="danger"
                    (click)="onConfirmResetStatus(ticket)">
                    <ion-icon name="refresh"></ion-icon>
                    Reset
                </ion-button>
            </ion-item-options>
            }
        </ion-item-sliding>
        }
    </ion-list>

</ion-content>

<!-- <ion-footer> -->
    <!-- <ion-toolbar data-test="validateButton"> -->
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button [disabled]=vb.disabled title="Next" color="primary" data-test="addTicketBtn" href="javascript:;"
            (click)="onTicketAdd()">
            <ion-icon name="add" color="light"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <!-- </ion-toolbar> -->
<!-- </ion-footer> -->